import React, {useState, useEffect, useRef} from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Select,
  MenuItem,
  IconButton,
  Button,
  Box,
  Typography,
  Paper,
  FormControl,
  TextField,
  FormHelperText,
  TableContainer,
  TextareaAutosize,
} from '@mui/material';
import {assets} from '../../../../../utils/assetsSrc';
import {useDispatch, useSelector} from 'react-redux';
import {toast} from 'react-toastify';
import {
  postActionItemData,
  getActionItemData,
  updateActionItemData,
  deleteActionItems,
  getUserList,
} from '../../../../../redux/risk-assessment-core/riskAssessmentCoreSlice'; // Import the action and selector
import {
  getActionListData,
  getUserListData,
} from '../../../../../redux/selectors/riskAssessmentCore';
import * as Yup from 'yup';
import TextArea from '../../../../../components/form/textArea/TextArea';
import AutoResizableTextArea from '../../../../../components/form/textArea/AutoResizeableTextArea';
import {EventStatusIds} from '../../../../../utils/constants';
const ActionRequired = ({
  setFieldValue,
  readOnly,
  errors,
  onClose,
  eventId,
  actionRequireValue,
  handleUpdateData,
  values,
  setFieldError,
  eventStatus,
  riskAssessmentId,
  eventName,
  taskName,
  riskAssessmentName,
  modelName,
  productLineName,
  onEditingRowsChange,
}) => {
  const actionOptions = [
    {label: 'Product management', value: '1'},
    {label: 'Engineering', value: '2'},
    {label: 'Product support', value: '3'},
    {label: 'Publications', value: '4'},
    {label: 'Training', value: '5'},
    {label: 'Other', value: '6'},
  ];
  const dispatch = useDispatch();
  const actionItemData = useSelector(getActionListData());
  const [rows, setRows] = useState([]);
  const [rowErrors, setRowErrors] = useState({});
  const userListData = useSelector(getUserListData());
  
  useEffect(() => {
    dispatch(getActionItemData(eventId));
    dispatch(getUserList());
  }, [eventId]);

  useEffect(() => {
    if (actionItemData && actionItemData.length > 0) {
      setRows(
        actionItemData?.map(item => ({
          id: item.id,
          actionValue:
            actionOptions.find(option => option.label === item.group)?.value ||
            '',
          details: item.description || '',
          dueDate: item.due_date || '',
          assignedTo: item.assigned_to || '',
          pue: item.pue || '',
          status: item.status || '',
          isEnable: false,
        })),
      );
    } else {
      setRows([]);
    }
  }, [actionItemData]);

  useEffect(() => {
    onEditingRowsChange?.(rows.some(row => row.isEnable));
  }, [rows]);

  const handleAddRow = () => {
    setRows(prev => [
      ...prev,
      {
        id: Date.now(),
        actionValue: '',
        details: '',
        dueDate: '',
        assignedTo: '',
        pue: eventId, // Set the pue field to eventId
        status: 'Open',
        isEnable: true,
        isNewRow: true,
      },
    ]);
  };

  const handleDeleteRow = id => {
    // if (eventStatus && (!rows || rows.length <= 1)) {
    //   setFieldError(
    //     'action_required_by',
    //     'Action is required when event status is filled',
    //   );
    // if (eventStatus && (!rows || rows.length <= 1)) {
    //   setFieldError(
    //     'action_required_by',
    //     'Action is required when event status is filled',
    //   );

    //   return;
    // }
    //   return;
    // }
    dispatch(
      deleteActionItems({
        id,
        callback: result => {
          if (result.status >= 200 && result.status < 300) {
            setRows(prev => prev.filter(row => row.id !== id));

            handleUpdateEventData(rows.filter(row => row.id !== id));
          }
        },
      }),
    );
  };

  // const handleCancelEdit = (id) => {
  //   const row = rows.find((row) => row.id === id);
  //   setRows((prev) =>
  //     prev.map((row) =>
  //       row.id === id
  //         ? { ...row, ...row.originalValues, isEnable: false }
  //         : row
  //     )
  //   );
  // };
  const updateRowField = (id, field, value) => {
    setRows(prev =>
      prev.map(row => (row.id === id ? {...row, [field]: value} : row)),
    );
    setRowErrors(prev => ({
      ...prev,
      [id]: {...prev[id], [field]: ''}, // Clear error when user updates field
    }));
  };

  const handleDropdownChange = (id, value) => {
    updateRowField(id, 'actionValue', value);

    // console.log(rows, rows.map(row => (row.id === id ? value : row.actionValue)))
    // setFieldValue(
    //   'action_required_by',
    //   rows.map(row => (row.id === id ? value : row.actionValue)),
    // );
  };

  const handleUpdateEventData = rows => {
    if (!handleUpdateData || !values) {
      return;
    }

    let eventStatus = EventStatusIds.COMPLETED;

    const isActionRequired = rows?.some(row => row?.status === 'Open');

    if (!isActionRequired && rows?.length > 0) {
      values['event_status'] = eventStatus;
    }

    const updatedGroups = [...new Set(rows?.map(row => row?.actionValue))];
    values['action_required_by'] = updatedGroups;

    handleUpdateData(values);
  };

  const handleSaveRow = async id => {
    const row = rows.find(row => row.id === id);

    try {
      await validationSchema.validate(row, {abortEarly: false});

      const payload = {
        description: row.details || '',
        group:
          actionOptions.find(option => option.value === row.actionValue)
            ?.label || '',
        due_date: row.dueDate || 'N/A',
        assigned_to: Number(row.assignedTo) || 0,
        pue: row.pue || 0,
        status: row.status || 'N/A',
        risk_assessment: riskAssessmentId,
        event_name: eventName,
        task_name: taskName || '',
        risk_assessment_name: riskAssessmentName || '',
        model_name: modelName || '',
        product_line_name: productLineName || '',
      };

      const handleApiResponse = (response, actionType) => {
        if (response?.data?.detail || response?.data?.errors) {
          const errorMessage =
            response?.data?.errors?.pue ||
            response?.data?.detail ||
            'An error occurred.';

          toast.error(`Failed to ${actionType} action item: ${errorMessage}`, {
            autoClose: 2000,
          });
        } else {
          toast.success(`Action item ${actionType}d successfully.`, {
            autoClose: 2000,
          });

          setRows(prev =>
            prev.map(r =>
              r.id === id
                ? {
                    ...r,
                    ...payload,
                    isEnable: false,
                    id: response?.data?.id || r.id,
                  }
                : r,
            ),
          );

          handleUpdateEventData(rows);
        }
      };

      if (row.isEnable) {
        if (row.isNewRow) {
          delete row.isNewRow;
          dispatch(
            postActionItemData({
              id: eventId,
              payload,
              callback: result => handleApiResponse(result, 'add'),
            }),
          );
        } else {
          dispatch(
            updateActionItemData({
              id,
              payload,
              callback: result => handleApiResponse(result, 'update'),
            }),
          );
        }
      } else {
        setRows(prev =>
          prev.map(row => (row.id === id ? {...row, isEnable: true} : row)),
        );
      }
    } catch (error) {
      const newErrors = {};
      error.inner.forEach(err => {
        newErrors[id] = {...newErrors[id], [err.path]: err.message};
      });
      setRowErrors(prev => ({...prev, ...newErrors})); // Store errors in state
    }
  };

  const validationSchema = Yup.object().shape({
    actionValue: Yup.string().required('Action Title is required'),
    details: Yup.string().required('Description is required'),
    dueDate: Yup.string()
      .nullable()
      .transform(value => (value === '' ? null : value))
      .required('Due Date is required'),

    assignedTo: Yup.number()
      .typeError('Assigned To is required') // Ensures clean message
      .required('Assigned To is required'),
    status: Yup.string().required('Status is required'),
  });

  return (
    <Box sx={{width: '100%', overflowX: 'auto'}}>
      <Paper elevation={3} sx={{padding: 3}}>
        <Typography variant="h6" gutterBottom>
          Action Items
        </Typography>

        <TableContainer>
          <Table sx={{minWidth: 650}}>
            <TableHead>
              <TableRow>
                {[
                  'Responsible Group',
                  'Description',
                  'Due Date',
                  'Status',
                  'Assigned To',
                  // 'PUE',
                  'Action',
                ].map(header => (
                  <TableCell
                    key={header}
                    sx={{fontWeight: 'bold', whiteSpace: 'nowrap'}}>
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map(row => {
                // const selectedValues = rows
                //   .map(r => r.actionValue)
                //   .filter(Boolean);
                // const availableOptions = actionOptions.filter(
                //   option =>
                //     row.actionValue === option.value ||
                //     !selectedValues.includes(option.value),
                // );

                const availableOptions = actionOptions;

                return (
                  <TableRow
                    key={row.id}
                    sx={{'&:hover': {backgroundColor: '#f5f5f5'}}}>
                    <TableCell>
                      <FormControl
                        fullWidth
                        error={!!rowErrors[row.id]?.actionValue}>
                        <Select
                          sx={{
                            '& .MuiSelect-select.Mui-disabled': {
                              WebkitTextFillColor: 'black',
                            },
                          }}
                          // value={row.actionValue || actionRequireValue}
                          value={row?.actionValue}
                          onChange={e =>
                            handleDropdownChange(row.id, e.target.value)
                          }
                          disabled={readOnly || !row.isEnable}
                          displayEmpty>
                          <MenuItem value="" disabled>
                            Select an option
                          </MenuItem>
                          {availableOptions.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                        {rowErrors[row.id]?.actionValue && (
                          <FormHelperText>
                            {rowErrors[row.id]?.actionValue}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </TableCell>

                    <TableCell style={{width: '50%', minWidth: '200px'}}>
                      <AutoResizableTextArea
                        sx={{
                          '& .MuiInputBase-input.Mui-disabled': {
                            WebkitTextFillColor: 'black',
                          },
                        }}
                        height={'auto'}
                        value={row.details}
                        onChange={e =>
                          updateRowField(row.id, 'details', e.target.value)
                        }
                        placeholder="Enter details"
                        disabled={readOnly || !row.isEnable}
                        fullWidth
                        variant="outlined"
                        error={!!rowErrors[row.id]?.details}
                        helperText={rowErrors[row.id]?.details}
                      />
                    </TableCell>

                    <TableCell>
                      <TextField
                        sx={{
                          '& .MuiInputBase-input.Mui-disabled': {
                            WebkitTextFillColor: 'black',
                          },
                        }}
                        value={row.dueDate}
                        onChange={e =>
                          updateRowField(row.id, 'dueDate', e.target.value)
                        }
                        placeholder="Enter due date"
                        disabled={readOnly || !row.isEnable}
                        type="date"
                        fullWidth
                        variant="outlined"
                        error={Boolean(rowErrors[row.id]?.dueDate)}
                        helperText={rowErrors[row.id]?.dueDate || ''}
                      />
                    </TableCell>

                    <TableCell>
                      <FormControl
                        fullWidth
                        error={!!rowErrors[row.id]?.status}>
                        <Select
                          sx={{
                            '& .MuiSelect-select.Mui-disabled': {
                              WebkitTextFillColor: 'black',
                            },
                          }}
                          value={row.status}
                          onChange={e =>
                            updateRowField(row.id, 'status', e.target.value)
                          }
                          disabled={readOnly || !row.isEnable}>
                          <MenuItem value="Open">Open</MenuItem>
                          <MenuItem value="Closed">Closed</MenuItem>
                        </Select>
                        {rowErrors[row.id]?.status && (
                          <FormHelperText>
                            {rowErrors[row.id]?.status}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </TableCell>

                    <TableCell>
                      <FormControl
                        fullWidth
                        error={Boolean(rowErrors[row.id]?.assignedTo)}>
                        <Select
                          sx={{
                            '& .MuiSelect-select.Mui-disabled': {
                              WebkitTextFillColor: 'black',
                            },
                          }}
                          value={row.assignedTo || ''}
                          onChange={e =>
                            updateRowField(row.id, 'assignedTo', e.target.value)
                          }
                          disabled={readOnly || !row.isEnable}
                          displayEmpty
                          size="large"
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: 300,
                                overflowY: 'auto',
                              },
                            },
                          }}>
                          <MenuItem value="" disabled>
                            Select Assigned To
                          </MenuItem>
                          {userListData?.map(user => (
                            <MenuItem key={user.id} value={user.id}>
                              { (!user?.first_name && !user?.last_name)? user?.email:`${user?.first_name ?? "N/A"} ${user?.last_name ?? ""}`}
                              {/* {user.username} */}
                              {/* {user?.name ?? 'N/A'}{' '} */}
                              {/* {user?.last_name ?? ''} */}
                            </MenuItem>
                          ))}
                        </Select>
                        {rowErrors[row.id]?.assignedTo && (
                          <FormHelperText>
                            {rowErrors[row.id]?.assignedTo}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </TableCell>

                    {/* <TableCell>
                      <Typography>{row.pue}</Typography>
                    </TableCell> */}

                    <TableCell>
                      {row.isEnable ? (
                        <Button
                          variant="contained"
                          disabled={readOnly}
                          onClick={() => handleSaveRow(row.id)}
                          className="custom-button"
                          size="small">
                          Save Row
                        </Button>
                      ) : (
                        <>
                          <IconButton
                            disabled={readOnly}
                            onClick={() => handleSaveRow(row.id)}
                            sx={{color: 'blue', marginLeft: 1}}>
                            <img src={assets.editIcon} alt="Edit" />
                          </IconButton>
                          <IconButton
                            disabled={readOnly}
                            onClick={() => handleDeleteRow(row.id)}
                            sx={{color: 'red'}}>
                            <img src={assets.deleteIcon} alt="Delete" />
                          </IconButton>
                        </>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <Box sx={{display: 'flex', justifyContent: 'flex-end', mt: 2}}>
          <Button
            disabled={readOnly}
            variant="contained"
            onClick={handleAddRow}
            className="custom-button">
            Add Row
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default ActionRequired;
